import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import InfoPageLink from 'src/components/info-page-link';

export const OurChoiceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${layout.measurements.spacing100};
  position: relative;
  gap: ${layout.measurements.spacing025};

  ${media.mediumUp`
      width: 320px;
  `}
`;

export const TitleRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr 1fr;
  align-items: center;
  gap: ${layout.measurements.spacing025};
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 16px;
`;

export const StyledPopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${layout.measurements.spacing075};
`;

export const StyledBlueInfoPageLink = styled(InfoPageLink)`
  color: ${p => p.theme.colors.maybeBlue700};
`;

export const StyleUnderlinedInfoPageLink = styled(InfoPageLink)`
  &:hover {
    color: ${p => p.theme.colors.maybeBlue700};
  }
  text-decoration: underline;
`;
